import { client, formatQueryParams } from 'util/sdk';

export const loadGroupAdmins = (data) =>
  client.admin.adminGroupAdmins.query(formatQueryParams(data));

export const addGroupAdmin = (data, auth) =>
  client.admin.adminGroupAdmins.create(data, { adminUserId: auth.id });

export const deleteGroupAdmin = ({ groupAdminId }, auth) =>
  client.admin.adminGroupAdmins(groupAdminId).delete({ adminUserId: auth.id });

export const updateGroupAdmin = ({ groupAdminId, ...data }, auth) =>
  client.admin
    .adminGroupAdmins(groupAdminId)
    .update(data, { adminUserId: auth.id });
